import clsx from 'clsx'
import classes from './styles.module.scss'

import type { CarregamentoProps } from './types'

export default function Carregamento({
  tamanho = 48,
  cor = '#a11071',
  className,
  ...props
}: CarregamentoProps): JSX.Element {
  const tamanhoDaBorda = Math.max(1.8, Math.min(4, Math.round(tamanho / 12)))

  return (
    <div
      className={clsx(classes.spinner, className)}
      style={{
        width: tamanho,
        height: tamanho,
        borderWidth: `${tamanhoDaBorda}px`,
        borderTopWidth: `${tamanhoDaBorda}px`,
        borderTopColor: cor,
      }}
      {...props}
    />
  )
}
